<template>
  <img
    class="simple-logo-icon"
    src="../assets/img/logo-simple.png"
    alt="Logo Icon"
  />
</template>
